<template>
    <div>
        <button class="btn btn-primary mb-3" @click="open_group = true"><i class="fas fa-plus"></i>&nbsp; New Group</button>
        <table class="table table-striped" v-if="groups.length > 0">
            <thead>
                <tr>
                    <th scope="col">Group</th>
                    <th scope="col">Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(group, index) in groups">
                    <td>{{group.name}}</td>
                    <td>
                        <button class="btn btn-primary btn-sm mr-1" @click="edit = true, group_id = group.id, open_group = true"><i class="far fa-edit"></i>&nbsp; Edit</button>
                        <button type="button" class="btn btn-danger btn-sm" @click="delete_group(index, group.id)"><i class="far fa-trash-alt"></i>&nbsp; Delete</button>
                    </td>
                </tr>
            </tbody>
        </table>  
        <div v-else-if="!loading">
            There are currently no groups created.
        </div>      

        <group-maker v-if="open_group" :edit="edit" :group-id="group_id" @closeModal="on_load"></group-maker>

        <loader :loading="loading"></loader>
    </div>
</template> 

<script>

import loader from './loader.vue';
import groupMaker from './groupMaker.vue';
import vSelect from 'vue-select';

export default {

    components: {
        loader,
        groupMaker,
    },

    data() {
        return {
            loading: true,
            edit: false,
            open_group: false,
            group_id: null,
            groups:[],
        };
    },

    mounted(){  
        this.on_load();
    },

    methods: {
        on_load(){
            this.loading = true;
            axios.get('/groups/list')
            .then(function (response) {
                this.groups = response.data.groups;
                this.loading = false;
                this.open_group = false;
                this.edit = false;
            }.bind(this))
            .catch(function (error) {
                alert(error);
            })
        },
        delete_group(index, id){
            let confirm = window.confirm("Are you sure you want to delete this group?");
            if(confirm){
                axios.delete('/groups/' + id)
                .then(function (response) {
                    this.on_load();
                }.bind(this))
                .catch(function (error) {
                    alert(error);
                }.bind(this))
            }
        }    
    },
};
</script>